module.exports = __webpack_public_path__ + "static/media/iconTwo.4805e06a.svg";